// extracted by mini-css-extract-plugin
module.exports = {"surveySnippet":"style_surveySnippet__1fek_","info":"style_info__4GLKp","unread":"style_unread__1__io"};